import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import _isEmpty from "lodash/isEmpty";
import _isFunction from "lodash/isFunction";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import exactMath from 'exact-math';
import { Row, Col, Paper, BorrowerExternalCreditForm, BorrowerExternalCreditItem } from 'components';
import { formTitle, noRecords } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerExternalCreditTab = function BorrowerExternalCreditTab(_ref) {
  var _borrower$external_cr, _borrower$external_cr2, _borrower$external_cr3, _borrower$external_cr4, _borrower$external_cr8, _borrower$external_cr9, _borrower$external_cr10;

  var borrower = _ref.borrower,
      idNumber = _ref.idNumber,
      onBorrowerChange = _ref.onBorrowerChange;
  var totalExternalCreditsAmount = (_borrower$external_cr = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr2 = borrower.external_credits) === null || _borrower$external_cr2 === void 0 ? void 0 : _borrower$external_cr2.reduce(function (n, _ref2) {
    var amount = _ref2.amount;
    return exactMath.add(Number(n), Number(amount));
  }, 0)) !== null && _borrower$external_cr !== void 0 ? _borrower$external_cr : 0;
  var totalExternalCreditsMonth = (_borrower$external_cr3 = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr4 = borrower.external_credits) === null || _borrower$external_cr4 === void 0 ? void 0 : _borrower$external_cr4.reduce(function (n, _ref3) {
    var monthly_payment = _ref3.monthly_payment;
    return exactMath.add(Number(n), Number(monthly_payment));
  }, 0)) !== null && _borrower$external_cr3 !== void 0 ? _borrower$external_cr3 : 0;

  var handleEdit = function handleEdit(data) {
    var _borrower$external_cr5;

    var editData = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr5 = borrower.external_credits) === null || _borrower$external_cr5 === void 0 ? void 0 : _borrower$external_cr5.map(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) === (data === null || data === void 0 ? void 0 : data.id) ? data : el;
    });
    _isFunction(onBorrowerChange) && onBorrowerChange(editData);
  };

  var handleDelete = function handleDelete(id) {
    var _borrower$external_cr6;

    var deleteData = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr6 = borrower.external_credits) === null || _borrower$external_cr6 === void 0 ? void 0 : _borrower$external_cr6.filter(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) !== id;
    });
    _isFunction(onBorrowerChange) && onBorrowerChange(deleteData);
  };

  var handleAdd = function handleAdd(data) {
    var _borrower$external_cr7;

    _isFunction(onBorrowerChange) && onBorrowerChange([].concat(_toConsumableArray((_borrower$external_cr7 = borrower === null || borrower === void 0 ? void 0 : borrower.external_credits) !== null && _borrower$external_cr7 !== void 0 ? _borrower$external_cr7 : []), [data]));
  };

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0432\u044A\u043D\u0448\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    margin: "0 0 2em 0"
  }, !_isEmpty(borrower === null || borrower === void 0 ? void 0 : borrower.external_credits) ? ___EmotionJSX(React.Fragment, null, borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr8 = borrower.external_credits) === null || _borrower$external_cr8 === void 0 ? void 0 : _borrower$external_cr8.map(function (el) {
    return ___EmotionJSX(BorrowerExternalCreditItem, {
      data: el,
      key: el === null || el === void 0 ? void 0 : el.id,
      onEdit: handleEdit,
      onDelete: handleDelete
    });
  }), ___EmotionJSX(Row, {
    align: "center",
    horizontalGap: 8,
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX("p", null, ___EmotionJSX("b", null, "\u041E\u0431\u0449\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u0438 \u043D\u0430 \u043C\u0435\u0441\u0435\u0446:"), " ", "".concat(totalExternalCreditsMonth, " ").concat(borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr9 = borrower.external_credits[0]) === null || _borrower$external_cr9 === void 0 ? void 0 : _borrower$external_cr9.currency))), ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX("p", null, ___EmotionJSX("b", null, "\u041E\u0431\u0449\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u0438:"), " ", "".concat(totalExternalCreditsAmount, " ").concat(borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr10 = borrower.external_credits[0]) === null || _borrower$external_cr10 === void 0 ? void 0 : _borrower$external_cr10.currency))))) : ___EmotionJSX("div", {
    css: noRecords
  }, ___EmotionJSX("p", null, "\u041D\u044F\u043C\u0430 \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438.")), ___EmotionJSX("h5", {
    css: formTitle
  }, "\u0414\u043E\u0431\u0430\u0432\u0438 \u0432\u044A\u043D\u0448\u0435\u043D \u043A\u0440\u0435\u0434\u0438\u0442"), ___EmotionJSX(BorrowerExternalCreditForm, {
    idNumber: idNumber,
    onBorrowerChange: handleAdd
  }))));
};

BorrowerExternalCreditTab.propTypes = {
  borrower: PropTypes.object,
  idNumber: PropTypes.string,
  onBorrowerChange: PropTypes.func
};
export default BorrowerExternalCreditTab;